// extracted by mini-css-extract-plugin
export default {"container":"CheckoutSuccessfulPage_container__evcv9"};